import { BaseModel } from "./BaseModel";

export class Label extends BaseModel {
  schema = "/label";
  constructor(params = {}) {
    return super(params, "/label");
  }
}
